import { useLocation } from 'react-router'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import { CLIENT_HOME } from '../../../../../common/constants/routingConstants'

export const useShowSidePanel = (): boolean => {
  const { isClientHeaderRedesignEnabled } = useFlags()
  const location = useLocation()
  return isClientHeaderRedesignEnabled && location.pathname === CLIENT_HOME.route
}
